import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { pageUrl } from 'utilities/pageUrl';

const RedirectToEnterpriseMembership = () => {
  const [redirected, setRedirected] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (redirected) return;

    setRedirected(true);
    navigate(
      pageUrl.createAccount({
        step: 'create_account',
        target: pageUrl.enterpriseMembershipAccessCode()
      }),
      { replace: true }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default RedirectToEnterpriseMembership;
